import RapidTestComponents from './components';

export const getDefaultDecimalPlaces = (key) => RapidTestComponents.find((component) => component.key === key)?.decimalPlaces ?? null;

export const resolveDecimalPlaces = (key, standard) => {
    if (standard?.decimal_places !== null && standard?.decimal_places !== undefined) {
        return standard.decimal_places;
    }
    return getDefaultDecimalPlaces(key);
};

const isEmpty = (value) => value === null || value === undefined || value === '';

export const formatRapidTestValue = (key, value, standard) => {
    if (isEmpty(value)) return value;
    const decimalPlaces = resolveDecimalPlaces(key, standard);
    if (decimalPlaces === null) return value;
    const num = Number(value);
    if (!Number.isFinite(num)) return value;
    return num.toFixed(decimalPlaces);
};

export const getDecimalStep = (key, standard) => {
    const decimalPlaces = resolveDecimalPlaces(key, standard);
    if (decimalPlaces === null) return 0.01;
    return Number((10 ** -decimalPlaces).toFixed(decimalPlaces));
};
